import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onRefresh, onExport, onSettings, isRefreshing }) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={onRefresh}
        disabled={isRefreshing}
        iconName="RefreshCw"
        className={isRefreshing ? 'animate-spin' : ''}
      >
        <span className="sr-only">Refresh data</span>
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        onClick={onExport}
        iconName="Download"
      >
        <span className="sr-only">Export data</span>
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        onClick={onSettings}
        iconName="Settings"
      >
        <span className="sr-only">Settings</span>
      </Button>
    </div>
  );
};

export default QuickActions;